import React from 'react';
import FooterSocialIcons from './FooterSocialIcons';
import { ArrowRightIcon } from './Icons';

import '../js/cookie.js';
import '../css/cookie.css';

const footerH5 = {
  fontWeight: "700",
  color: "#2b185a",
}

const footerCAll = {
  fontSize: "14px",
  lineHeight: "10px",
  color: "#707070",
  marginTop: "15px"
}

const footerContact = {
  color: "#2b185a",
  fontWeight: "600",
  textDecoration: "none"
}
const Footer = () => {
  return (
    <>
      <footer className="worldwide pb-3 pt-5">
        <div className="container-fluid ps-3 pe-3 ps-md-5 pe-md-5">
          <div className="secoundry-footer">
            <div className="row">
              <div className="col-md-9 col-12">
                <h4 style={footerH5}>Feel free to call us. We are available 24/7 for your support.</h4>
                <p style={footerCAll} className="mb-2">CALL US AT</p>
                <p style={footerContact}>UK:
                  <a style={footerContact} href="tel:+44-800-102-6200"> +44-800-102-6200 </a>/ US: <a href="tel:+1-877-879-4339" style={footerContact}>+1-877-879-4339 </a>/ AUS: <a href="tel:+61-871-401-005" style={footerContact}>+61-871-401-005 </a>
                </p>
              </div>
              <div className="col-md-3 col-12 text-end">
                <a className="nav-link btn header-menu-btn gf-btn me-3 mt-3" href="/contact-us">
                  <span className="d-flex align-content-center justify-content-center pt-1 pb-1">Get in touch <ArrowRightIcon className="ms-1" /></span>
                </a>
              </div>
              <div className="col-md-12">
                <hr></hr>
              </div>
            </div>
          </div>
          <div className="primary-footer">
            <div className="row hide-in-mobile justify-content-around">
              <div className="col-md-3 wrapper-col-1">
                <img alt="logo" className="img-fluid mb-3" src="/assets/images/GF-logo.svg" style={{ width: "150px" }} />
                <p className="footer-text" style={{ textAlign: "justify" }}>GetFriday, the World's leading Virtual Assistant services since 2005. We help busy individuals, Startups &amp; Small businesses, handle their personal and business needs better.</p>
              </div>
              <div className="col-md-1 wrapper-col-2">
                <h6 className="footer-heading pb-1 mt-2">Company</h6>
                <ul className="footer-list-ul pt-2">
                  <li className="footer-list pb-2"><a href="/about-us" className="footer-list-link">About us</a></li>
                  <li className="footer-list pb-2"><a href="/contact-us" className="footer-list-link">Contact us</a></li>
                  <li className="footer-list pb-2"><a href="https://www.ttkservices.com/career/career.php" target="_blank" rel="noopener noreferrer" className="footer-list-link">Careers</a></li>
                  <li className="footer-list pb-2"><a href="/press-and-media" className="footer-list-link">Press</a></li>
                  <li className="footer-list pb-2"><a href="https://www.getfriday.com/blog/" target="_blank" rel="noopener noreferrer" className="footer-list-link">Blog</a></li>
                </ul>
              </div>
              <div className="col-md-2 wrapper-col-3">
                <h6 className="footer-heading pb-1 mt-2">GetFriday</h6>
                <ul className="footer-list-ul pt-2">
                  <li className="footer-list pb-2"><a href="/why-getfriday" className="footer-list-link">Why GetFriday</a></li>
                  <li className="footer-list pb-2"><a href="/how-we-work" className="footer-list-link">How it works</a></li>
                  <li className="footer-list pb-2"><a href="/faqs" className="footer-list-link">FAQ's</a></li>
                  <li className="footer-list pb-2"><a href="/sitemap" className="footer-list-link">SiteMap</a></li>
                  <li className="footer-list pb-2"><a href="/4-hour-workweek-ymii" className="footer-list-link">4-Hour Workweek</a></li>
                </ul>
              </div>

              <div className="col-md-2 wrapper-col-4">
                <h6 className="footer-heading pb-1 mt-2">Services</h6>
                <ul className="footer-list-ul pt-2">
                  <li className="footer-list pb-2"><a href="/personal/virtual-personal-assistant" className="footer-list-link">Personal VA</a></li>
                  <li className="footer-list pb-2"><a href="/business/services" className="footer-list-link">Business Support</a></li>
                  <li className="footer-list pb-2"><a href="/business/bookkeeping-service" className="footer-list-link">BookKeeping</a></li>
                  <li className="footer-list pb-2"><a href="/business/website-services" className="footer-list-link">Website Development</a></li>
                  <li className="footer-list pb-2"><a href="/business/digital-marketing" className="footer-list-link">Digital Marketing</a></li>
                </ul>
              </div>

              <div className="col-md-2 wrapper-col-5">
                <h6 className="footer-heading pb-1 mt-2">Legal</h6>
                <ul className="footer-list-ul pt-2">
                  <li className="footer-list pb-2"><a href="/privacy-policy" className="footer-list-link">Privacy Policy</a></li>
                  <li className="footer-list pb-2"><a href="/terms-and-conditions" className="footer-list-link">Terms & Conditions</a></li>
                  <li className="footer-list pb-2"><a href="/refund-policy" className="footer-list-link">Refund Policy</a></li>
                  <li className="footer-list pb-2"><a href="/disclaimer" className="footer-list-link">Disclaimer</a></li>
                  <li className="footer-list pb-2"><a href="/copyright" className="footer-list-link">Copyright</a></li>
                </ul>
              </div>

              <div className="col-md-2 wrapper-col-6">
                <h6 className="footer-heading pb-1 mt-2">Social Links</h6>
                <FooterSocialIcons />
                <img loading="lazy" decoding="async" src="/assets/images/Thumb_mark.jpg" height="70px" alt="icon img responsive"></img>
              </div>
              <div className="col-md-12">
                <p className="pt-4 text-center copyrights footer-text"> © {new Date().getFullYear()} Copyright, All Right Reserved, Made by GetFriday</p>
              </div>
            </div>
            <div className="row show-in-mobile">
              <div className="col-md-12">
                <img alt="logo" className="img-fluid mb-3" src="/assets/images/GF-logo.svg" style={{ width: "150px" }} />
                <p className="footer-text" style={{ textAlign: "justify" }}>GetFriday, the World's leading Virtual Assistant services since 2005. We help busy individuals, Startups &amp; Small businesses, handle their personal and business needs better.</p>
              </div>
              <div className="col-md-12">
                <div className="accordion accordion-flush">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingOne">
                      <button className="accordion-button collapsed footer-topic" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">Company</button>
                    </h2>
                    <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                      <div className="accordion-body">
                        <ul className="footer-list-ul pt-2">
                          <li className="footer-list pb-2"><a href="/about-us" className="footer-list-link">About us</a></li>
                          <li className="footer-list pb-2"><a href="/contact-us" className="footer-list-link">Contact us</a></li>
                          <li className="footer-list pb-2"><a href="https://www.ttkservices.com/career/career.php" target="_blank" rel="noopener noreferrer" className="footer-list-link">Careers</a></li>
                          <li className="footer-list pb-2"><a href="/press-and-media" className="footer-list-link">Press</a></li>
                          <li className="footer-list pb-2"><a href="https://www.getfriday.com/blog/" target="_blank" rel="noopener noreferrer" className="footer-list-link">Blog</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingTwo">
                      <button className="accordion-button collapsed footer-topic" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">GetFriday</button>
                    </h2>
                    <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                      <div className="accordion-body">
                        <ul className="footer-list-ul pt-2">
                          <li className="footer-list pb-2"><a href="/why-getfriday" className="footer-list-link">Why GetFriday</a></li>
                          <li className="footer-list pb-2"><a href="/how-we-work" className="footer-list-link">How it works</a></li>
                          <li className="footer-list pb-2"><a href="/faqs" className="footer-list-link">FAQ's</a></li>
                          <li className="footer-list pb-2"><a href="/sitemap" className="footer-list-link">SiteMap</a></li>
                          <li className="footer-list pb-2"><a href="/4-hour-workweek-ymii" className="footer-list-link">4-Hour Workweek</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingFour">
                      <button className="accordion-button collapsed footer-topic" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">Services</button>
                    </h2>
                    <div id="flush-collapseFour" className="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
                      <div className="accordion-body">
                        <ul className="footer-list-ul pt-2">
                          <li className="footer-list pb-2"><a href="/personal/virtual-personal-assistant" className="footer-list-link">Personal VA</a></li>
                          <li className="footer-list pb-2"><a href="/business/services" className="footer-list-link">Business Support</a></li>
                          <li className="footer-list pb-2"><a href="/business/bookkeeping-service" className="footer-list-link">BookKeeping</a></li>
                          <li className="footer-list pb-2"><a href="/business/website-services" className="footer-list-link">Website Development</a></li>
                          <li className="footer-list pb-2"><a href="/business/digital-marketing" className="footer-list-link">Digital Marketing</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingThree">
                      <button className="accordion-button collapsed footer-topic" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">Legal</button>
                    </h2>
                    <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                      <div className="accordion-body">
                        <ul className="footer-list-ul pt-2">
                          <li className="footer-list pb-2"><a href="/privacy-policy" className="footer-list-link">Privacy Policy</a></li>
                          <li className="footer-list pb-2"><a href="/terms-and-conditions" className="footer-list-link">Terms & Conditions</a></li>
                          <li className="footer-list pb-2"><a href="/refund-policy" className="footer-list-link">Refund Policy</a></li>
                          <li className="footer-list pb-2"><a href="/disclaimer" className="footer-list-link">Disclaimer</a></li>
                          <li className="footer-list pb-2"><a href="/copyright" className="footer-list-link">Copyright</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 text-center">
                <p className="pt-4 text-center copyrights footer-text"> © {new Date().getFullYear()} Copyright, All Right Reserved, Made by GetFriday</p>
                <FooterSocialIcons />
                <img loading="lazy" decoding="async" src="/assets/images/Thumb_mark.jpg" height="70px" alt="icon img responsive"></img>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer